import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SpotlightEvent } from 'src/app/dto';

@Component({
    selector: 'app-spotlight-carousel',
    templateUrl: './spotlight-carousel.component.html',
    styleUrls: ['./spotlight-carousel.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightCarouselComponent {
    @Input() events: SpotlightEvent[] = [];
    @Input() startEventId: string = null;
}
